import Loader from "react-loader-spinner";
import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addNewPreCustomer, convertPreCustomerToCustomer, editPreCustomer, addRelatedSection, deleteRelatedSection, getCustomerRelatedSections, getPreCutomer } from "../../store/api/CustomerApi";
import { setMapPop, setPopupMenu, setReferDocPop, setSelectStaffPopup } from "../../store/api/Modals";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { getCityList, getZoneList } from "../../store/api/LocationAPI";
import { Button, Col, Table } from "react-bootstrap";
import { CalendarDate, Check2, CheckLg, Command, DashCircle, FileEarmarkPerson, GeoAltFill, List, PlusSquare, ReplyFill, Toggles, Trash } from "react-bootstrap-icons";
import ModalReferDocument from "../ModalReferDocument.js";
import ModalReminder from "../../../Components/Modals/ModalReminder";
import ModalMap from "../ModalMap.js";
import { getPreCustomerExtAttrSettings } from "../../store/api/SystemSettingsAPI";
import ModalCommands from "../../../Components/Modals/ModalCommands";
import { setErrorDialog } from "../../../store/api/CommonFunctions.js";

const CustomerInfo = (props) => {
    const { id } = props;
    const history = useHistory();
    const sectionData = useRef({});
    const [customer, setCustomerData] = useState("PENDING");
    const locationCmbClicked = useRef(false);
    const [isPending, setPending] = useState(false);
    const [sectionError, setSectionError] = useState({});
    const { register, handleSubmit, errors } = useForm();
    const [selectedAgency, selectAgency] = useState(null);
    const [relatedSections, setRelatedSections] = useState([]);
    const [showAddSection, setShowAddSection] = useState(false);
    const [pendingSection, setPendingSection] = useState(false);
    const [popCommand, setPopCommand] = useState({ show: false });
    const [popReminder, setPopReminder] = useState({ show: false });
    const { settings, extSettings } = useSelector(state => { return { settings: state.SystemSettingsReducer.systemSettings, extSettings: state.SystemSettingsReducer.preCustomerExtAttrSettings } });
    const { baseInfoes } = useSelector(state => { return { baseInfoes: state.customerDataReducer.preCustomerBaseInfoes } });
    const { provinceList, cityList, zoneList, currentLocation } = useSelector(state => {
        return {
            provinceList: state.locationDataReducer.provinceList,
            cityList: state.locationDataReducer.cityList,
            zoneList: state.locationDataReducer.zoneList,
            currentLocation: state.locationDataReducer.currentLocation
        }
    });
    const dispatch = useDispatch();
    const onProvinceChanged = (provinceID) => {
        locationCmbClicked.current = true;
        dispatch(getCityList(provinceID));
        dispatch(getZoneList());
    }
    const onCityChanged = (cityID) => {
        locationCmbClicked.current = true;
        dispatch(getZoneList(cityID));
    }
    const showSelectStaff = (e) => {
        if (e.key && e.key === "Enter") {
            return;
        }
        dispatch(setSelectStaffPopup({ show: true, forAgency: true, forMiddleman: false, onSelect: selectAgency }));
    }
    const onSubmit = (data) => {
        data.Latitude = currentLocation?.lat;
        data.Longtitude = currentLocation?.lng;
        const onError = () => {
            setPending(false);
        }
        if (Number(id) > 0) {
            const onSuccess = () => {
                setPending(false);
            }
            data.ID = Number(id);
            setPending(true);
            dispatch(editPreCustomer(data, onSuccess, onError))
        }
        else {
            const onSuccess = (result) => {
                setPending(false);
                history.replace("/CRM/AddEditPreCustomer/" + result.ID);
            }
            setPending(true);
            dispatch(addNewPreCustomer(data, onSuccess, onError));
        }
    }
    function showCommand() {
        setPopCommand({
            show: true,
            attachmentType: "precustomer",
            attachmentID: id
        })
    }

    const showDocRefer = () => {
        dispatch(setReferDocPop({ show: true, documentHardCode: "pre_customer", documentID: id }));
    }
    const showReminerPop = () => {
        setPopReminder({ show: true });
    }
    const showMenu = (e) => {
        const menuItems = [
            { icon: <CalendarDate />, title: "افزودن یادآوری", onClick: showReminerPop },
            { icon: <ReplyFill />, title: "ارجاع به کارتابل کاربر", onClick: showDocRefer },
            { icon: <Command />, title: "دستور کار", onClick: showCommand }];
        dispatch(setPopupMenu({ title: "سایر عملیات", show: true, top: e.clientY - 100, menuItems: menuItems, left: e.clientX }));
    }
    const convertToCustomer = () => {
        const onSuccess = (res) => {
            history.push("/CRM/AddEditCustomer/" + res.ID);
        }
        dispatch(convertPreCustomerToCustomer(customer, onSuccess));
    }
    function showRelatedCustomer() {
        history.push("/CRM/AddEditCustomer/" + customer.RelatedCustomerID);
    }
    const checkNationalCode = (Name) => {
        if (Name.length === 10) {
            if (Name === '1111111111' ||
                Name === '0000000000' ||
                Name === '2222222222' ||
                Name === '3333333333' ||
                Name === '4444444444' ||
                Name === '5555555555' ||
                Name === '6666666666' ||
                Name === '7777777777' ||
                Name === '8888888888' ||
                Name === '9999999999') {
                return false;
            }
            let c = parseInt(Name.charAt(9));
            let n = parseInt(Name.charAt(0)) * 10 +
                parseInt(Name.charAt(1)) * 9 +
                parseInt(Name.charAt(2)) * 8 +
                parseInt(Name.charAt(3)) * 7 +
                parseInt(Name.charAt(4)) * 6 +
                parseInt(Name.charAt(5)) * 5 +
                parseInt(Name.charAt(6)) * 4 +
                parseInt(Name.charAt(7)) * 3 +
                parseInt(Name.charAt(8)) * 2;
            let r = n - parseInt(n / 11) * 11;
            if (!((r === 0 && r === c) || (r === 1 && c === 1) || (r > 1 && c === 11 - r))) {
                return false;
            }
            else {
                return true;
            }
        }
        // else if (Name === '') {
        //     const nationalCodeIsRequired = settings && settings.find(s => s.SettingName === "NationalCodeIsRequired")?.SettingValue.toLowerCase() === "true";
        //     return !nationalCodeIsRequired;
        // }
        else if (Name !== '') {
            return false;
        }
        else {
            return true;
        }

    }
    const addNewSection = (e) => {
        if (e.key) {
            if (e.key !== "Enter") {
                return;
            }
            e.preventDefault();
        }
        let er = {};
        if (!sectionData.current.SectionName || sectionData.current.SectionName === "") {
            er.SectionName = "N";
        }
        if (!sectionData.current.SectionResponsible || sectionData.current.SectionResponsible === "") {
            er.Responsible = "N";
        }
        setSectionError(er);
        if (Object.keys(er).length > 0 || pendingSection) {
            return;
        }
        const onSuccess = (res) => {
            sectionData.current.ID = res.ID;
            const newArr = [...relatedSections, sectionData.current];
            setRelatedSections(newArr);
            sectionData.current = {};
            setShowAddSection(false);
            setPendingSection(false);
        }
        setPendingSection(true);
        sectionData.current.CustomerID = id;
        sectionData.current.IsPreCustomer = true;
        dispatch(addRelatedSection(sectionData.current, onSuccess));

    }
    const deleteSection = (secID) => {
        const onSuccess = () => {
            setRelatedSections(relatedSections.filter(s => s.ID !== secID));
        }
        dispatch(deleteRelatedSection(secID, onSuccess));
    }
    function showDivSection() {
        const f = async () => { setShowAddSection(true) };
        f().then(() =>
            document.getElementById("inputSectionName")?.focus());
    }
    useEffect(() => {
        setCustomerData("PENDING");
        dispatch(getPreCustomerExtAttrSettings());
        if (Number(id) > 0) {
            getCustomerRelatedSections(id, true, setRelatedSections);
            const onGet = (res) => {
                if (res?.Name) {
                    setCustomerData(res);
                }
                else if (res.Error) {
                    setErrorDialog(dispatch, res.Error, "مشتری بالقوه");
                }
            }
            getPreCutomer(id, onGet);
        }
        else {
            setTimeout(() => { setCustomerData(null); }, 10);
        }
    }, [id])
    return (
        <Fragment>
            {Number(id) > 0 && <ModalReferDocument />}
            <ModalCommands popData={popCommand} setPopData={setPopCommand} />
            {Number(id) > 0 && <ModalReminder attachmentID={id} attachmentType="pre_customer" pop={popReminder} setPop={setPopReminder} />}
            <ModalMap location={{ lat: !customer || !customer.Latitude || Number(customer.Latitude) === 0 ? 35.6996 : customer.Latitude, lng: !customer || !customer.Longtitude || Number(customer.Longtitude) === 0 ? 51.3380 : customer.Longtitude, zoom: 9 }} />
            <input type="hidden" value={id} />
            {customer === "PENDING" &&
                <div style={{ textAlign: "center" }}>
                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                </div>}
            {customer !== "PENDING" && settings && settings.length > 0 &&
                <form onSubmit={handleSubmit(onSubmit)} readOnly>
                    <div className="row rowBorder mt-3">
                        <div className="rowTitle">اطلاعات فردی</div>
                        <Col md={2} className="form-group" >
                            <label>نام</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                            <input type="text" className="form-control" name="FirstName" ref={register({ required: true })}
                                defaultValue={customer?.FirstName ?? ""} />
                            {errors.Name && <small className="errors"> نام خانوادگی را وارد کنید </small>}
                        </Col>                        
                        <Col md={2} className="form-group" >
                            <label>نام خانوادگی</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                            <input type="text" className="form-control" name="Name" ref={register({ required: true })}
                                defaultValue={customer?.Name ?? ""} />
                            {errors.Name && <small className="errors"> نام خانوادگی را وارد کنید </small>}
                        </Col>
                        <Col md={2} className="form-group" >
                            <label>شماره ملی</label>
                            <input type="text" className="form-control" name="NationalCode" ref={register({ validate: checkNationalCode })}
                                defaultValue={customer?.NationalCode ?? ""} />
                            {errors.NationalCode && <small className="errors">کد ملی معتبر نیست</small>}
                        </Col>
                        <Col md={2} className="form-group" >
                            <label>تلفن</label>
                            <input type="text" className="form-control" name="Phone" ref={register({})}
                                defaultValue={customer?.Phone ?? ""} />
                            {/* {errors.Phone && <small className="errors"> تلفن مشتری را وارد کنید</small>} */}
                        </Col>
                        <Col md={2} className="form-group" >
                            <label>شماره همراه</label>
                            <input type="text" className="form-control" name="Mobile" ref={register({})}
                                defaultValue={customer?.Mobile ?? ""} />
                            {/* {errors.CustomerAccountType && <small className="errors"> موبایل مشتری را وارد کنید</small>} */}
                        </Col>
                        <Col md={2} className="form-group" >
                            <label>دورنگار</label>
                            <input type="text" className="form-control" name="Fax" ref={register({})}
                                defaultValue={customer?.Fax ?? ""} />
                        </Col>
                        <Col md={2} className="form-group" >
                            <label>Email</label>
                            <input type="text" className="form-control" name="Email" ref={register({})}
                                defaultValue={customer?.Email ?? ""} />
                        </Col>
                        <Col md={2} className="form-group" >
                            <label>استان</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                            {provinceList === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {provinceList && Array.isArray(provinceList) &&
                                <select className="form-control" name="ProvinceID" ref={register({ required: true })}
                                    defaultValue={customer?.ProvinceID ?? ""}
                                    onChange={e => onProvinceChanged(e.target.value)}>
                                    <option value="">انتخاب کنید</option>
                                    {provinceList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}
                                </select>
                            }
                            {errors.ProvinceID && <small className="errors"> انتخاب استان الزامی است</small>}
                        </Col>
                        <Col className="form-group" >
                            <label>شهر</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                            {cityList === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {cityList && Array.isArray(cityList) &&
                                <select className="form-control" name="CityID" ref={register({ required: true })}
                                    onChange={e => onCityChanged(e.target.value)}
                                    defaultValue={customer?.CityID ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {locationCmbClicked.current &&
                                        cityList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)
                                    }
                                    {!locationCmbClicked.current && customer && customer.CityID &&
                                        <option value={customer.CityID}>{customer.CityName}</option>
                                    }
                                </select>}
                            {errors.CityID && <small className="errors"> انتخاب شهر الزامی است</small>}
                        </Col>
                        <Col className="form-group">
                            <label>منطقه</label>
                            {zoneList === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {zoneList && Array.isArray(zoneList) &&
                                <select className="form-control" name="ZoneID" ref={register({})}
                                    defaultValue={customer?.ZoneId ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {locationCmbClicked.current && zoneList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}
                                    {!locationCmbClicked.current && customer && customer.ZoneId &&
                                        <option value={customer.ZoneId}>{customer.ZoneName}</option>
                                    }
                                </select>
                            }
                        </Col>
                        <Col md={2} className="form-group" >
                            <label>خیابان اصلی</label>
                            <input type="text" className="form-control" name="MainStreet"
                                ref={register({})} defaultValue={customer?.Mainstreet ?? ""} />
                        </Col>
                        <Col md={2} className="form-group" >
                            <label>خیابان فرعی</label>
                            <input type="text" className="form-control" name="SubStreet"
                                ref={register({})} defaultValue={customer?.SubStreet ?? ""} />
                        </Col>
                        <div className="form-group col-md-4" >
                            <div><label>نشانی</label><span style={{ color: "red", fontSize: "13px" }}>*</span></div>
                            <input type="text" className="form-control" name="Address"
                                ref={register({ required: true })} defaultValue={customer?.Address ?? ""} />
                            <Button className='btn-input-tiny' onClick={() => dispatch(setMapPop({ show: true }))}><GeoAltFill size={20} /></Button>
                            {errors.Address && <small className="errors"> آدرس را وارد کنید</small>}
                        </div>
                    </div>
                    <div className="row rowBorder mt-3">
                        <div className="rowTitle">اطلاعات سیستمی</div>
                        <Col md={2} className="form-group" >
                            <label>رسته شغلی</label>
                            {baseInfoes === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {baseInfoes?.JobList && Array.isArray(baseInfoes.JobList) &&
                                <select className="form-control" name="JobId" ref={register({})}
                                    defaultValue={customer?.JobId ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {baseInfoes.JobList.map((item, i) => <option key={i} value={item.JobId}>{item.Job}</option>)}
                                </select>
                            }
                        </Col>
                        <Col md={2} className="form-group" >
                            <label>وضعیت مشتری</label>
                            {baseInfoes === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {baseInfoes?.StatusList && Array.isArray(baseInfoes.StatusList) &&
                                <select className="form-control" name="StatusID" ref={register({})}
                                    defaultValue={customer?.StatusID ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {baseInfoes.StatusList.map((item, i) => <option key={i} value={item.ID}>{item.Status}</option>)}
                                </select>
                            }
                        </Col>
                        <Col md={2} className="form-group" >
                            <label>نحوه آشنایی</label>
                            {baseInfoes === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {baseInfoes?.HowToKnowList && Array.isArray(baseInfoes.HowToKnowList) &&
                                <select className="form-control" name="HowToKnow" ref={register({})}
                                    defaultValue={customer?.HowToKnow ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {baseInfoes.HowToKnowList.map((item, i) => <option key={i} value={item.ID}>{item.InfoName}</option>)}
                                </select>
                            }
                        </Col>
                        <Col md={2} className="form-group" >
                            <label>کمپین فروش</label>
                            {baseInfoes === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {baseInfoes?.CampaignList && Array.isArray(baseInfoes.CampaignList) &&
                                <select className="form-control" name="CampaignID" ref={register({})}
                                    defaultValue={customer?.CampaignID ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {baseInfoes.CampaignList.map((item, i) => <option key={i} value={item.Item1}>{item.Item2}</option>)}
                                </select>
                            }
                        </Col>
                        <Col md={2} className="form-group" >
                            <label>نام نمایندگی</label>
                            <input type="hidden" name="AgentId" ref={register({})} readOnly value={selectedAgency ? selectedAgency.ID : customer?.AgencyID ?? ""} />
                            <input type="text" className="form-control" readOnly onKeyDown={showSelectStaff}
                                value={selectedAgency ? selectedAgency.LastName : customer?.AgentName ?? ""} />
                            <Button className="btn-input-tiny" onClick={showSelectStaff}><List size={18} /></Button>
                        </Col>
                        <Col md={2} className="form-group" >
                            <label>رقیب</label>
                            {baseInfoes === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {baseInfoes?.CompetitorList && Array.isArray(baseInfoes.CompetitorList) &&
                                <select className="form-control" name="CompetitorID" ref={register({})}
                                    defaultValue={customer?.CompetitorID ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {baseInfoes.CompetitorList.map((item, i) => <option key={i} value={item.ID}>{item.Name}</option>)}
                                </select>
                            }
                        </Col>
                        <Col md={2} className="form-group">
                            <label>احتمال خرید</label>
                            <input type="number" name="PurchasePossibility" className="form-control" ref={register({})}
                                defaultValue={customer?.PurchasePossibility ?? ""} />
                        </Col>
                        <Col md={2} className="form-group" >
                            <label>زمان تقریبی خرید</label>
                            {baseInfoes === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {baseInfoes?.EstimatedTimeList && Array.isArray(baseInfoes.EstimatedTimeList) &&
                                <select className="form-control" name="EstimatedTimeForPursh" ref={register({})}
                                    defaultValue={customer?.EstimatedTimeForPursh ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {baseInfoes.EstimatedTimeList.map((item, i) => <option key={i} value={item.InfoName}>{item.InfoName}</option>)}
                                </select>
                            }
                        </Col>
                        <Col md={2} className="form-group" >
                            <label>دلیل عدم تمایل</label>
                            {baseInfoes === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                </div>
                            }
                            {baseInfoes?.UnwillingnessList && Array.isArray(baseInfoes.UnwillingnessList) &&
                                <select className="form-control" name="Unwillingness" ref={register({})}
                                    defaultValue={customer?.Unwillingness ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    {baseInfoes.UnwillingnessList.map((item, i) => <option key={i} value={item.ID}>{item.InfoName}</option>)}
                                </select>
                            }
                        </Col>

                        <Col md={2} className="form-group" >
                            <label>توضیحات</label>
                            <input type="text" className="form-control" name="Description" ref={register({})}
                                defaultValue={customer?.Description ?? ""} />
                        </Col>
                    </div>
                    {extSettings && extSettings.length > 0 && Array.isArray(extSettings) &&
                        < div className="row rowBorder mt-3">
                            <div className="rowTitle">سایر مشخصه ها</div>
                            {extSettings.map((setting, i) => {
                                return (
                                    <div className="form-group col-md-3" key={i}>
                                        <label>{setting.SettingValue}</label>
                                        {setting.SettingName === "PreCustomer_Axt1" &&
                                            <Fragment>
                                                {baseInfoes === "PENDING" &&
                                                    <div className="form-control">
                                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                                    </div>
                                                }
                                                {baseInfoes?.Ext1List && Array.isArray(baseInfoes.Ext1List) &&
                                                    <select className="form-control" name="Axt1" ref={register({})}
                                                        defaultValue={customer?.Axt1 ?? ""}>
                                                        <option value="">انتخاب کنید</option>
                                                        {baseInfoes.Ext1List.map((item, i) => <option key={i} value={item.InfoName}>{item.InfoName}</option>)}
                                                    </select>
                                                }
                                            </Fragment>
                                        }
                                        {setting.SettingName === "PreCustomer_Axt10" &&
                                            <Fragment>
                                                {baseInfoes === "PENDING" &&
                                                    <div className="form-control">
                                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                                    </div>
                                                }
                                                {baseInfoes?.Ext10List && Array.isArray(baseInfoes.Ext10List) &&
                                                    <select className="form-control" name="Axt10" ref={register({})}
                                                        defaultValue={customer?.Axt10 ?? ""}>
                                                        <option value="">انتخاب کنید</option>
                                                        {baseInfoes.Ext10List.map((item, i) => <option key={i} value={item.InfoName}>{item.InfoName}</option>)}
                                                    </select>
                                                }
                                            </Fragment>
                                        }
                                        {setting.SettingName !== "PreCustomer_Axt10" && setting.SettingName !== "PreCustomer_Axt1" &&
                                            <input type="text" className="form-control" name={"Axt" + (i + 1)} ref={register({})}
                                                defaultValue={customer && customer["Axt" + (i + 1)] ? customer["Axt" + (i + 1)] : ""} />
                                        }
                                    </div>
                                )
                            })
                            }
                        </div>
                    }
                    {Number(id) > 0 &&
                        <div className="row mt-3">
                            <div className="col-md-6">
                                <label style={{ color: "blue", fontWeight: "bold" }}>بخش های مرتبط</label>
                                &nbsp;
                                <PlusSquare size={19} color="#086679" style={{ cursor: "pointer" }} onClick={showDivSection} />
                                <hr style={{ color: "red", height: "2px", marginTop: "2px", marginBottom: "0" }} />
                                {showAddSection &&
                                    <div className="row" style={{ paddingRight: "10px" }}>
                                        <div className="col-md-3 form-group" style={{ padding: "3px" }}>
                                            <input id="inputSectionName" className="form-control tableRowInput" placeholder="نام بخش"
                                                onChange={e => sectionData.current.SectionName = e.target.value} onKeyDown={addNewSection} />
                                            {sectionError.SectionName && <small className="errors">نام بخش الزامی است</small>}
                                        </div>
                                        <div className="col-md-2 form-group" style={{ padding: "3px" }}>
                                            <input className=" form-control tableRowInput" placeholder="مسئول بخش"
                                                onChange={e => sectionData.current.SectionResponsible = e.target.value} onKeyDown={addNewSection} />
                                            {sectionError.Responsible && <small className="errors">مسئول بخش الزامی است</small>}
                                        </div>
                                        <div className="col-md-2 form-group" style={{ padding: "3px" }}>
                                            <input className=" form-control tableRowInput" placeholder="تلفن بخش"
                                                onChange={e => sectionData.current.SectionPhone = e.target.value} onKeyDown={addNewSection} />
                                        </div>
                                        <div className="col-md-1 form-group" style={{ padding: "3px" }}>
                                            <input className=" form-control tableRowInput" placeholder="داخلی"
                                                onChange={e => sectionData.current.SectionInternalNumber = e.target.value} onKeyDown={addNewSection} />
                                        </div>
                                        <div className="col-md-2 form-group" style={{ padding: "3px" }}>
                                            <input type="number" className=" form-control tableRowInput" placeholder="ترتیب نمایش"
                                                onChange={e => sectionData.current.SectionItemOrder = e.target.value} onKeyDown={addNewSection}
                                                defaultValue={0} />
                                        </div>
                                        <div className="col-md-2  form-group" style={{ marginTop: "18px" }}>
                                            <Button className="group-Btn-smalll" variant="success" onClick={addNewSection}>
                                                {pendingSection && <Loader type="BallTriangle" color="white" height={20} width={20} />}
                                                {!pendingSection && <Check2 size={17} />}
                                            </Button>
                                            <Button className="group-Btn-smalll" variant="danger" onClick={e => setShowAddSection(false)}> <DashCircle size={17} /></Button>
                                        </div>
                                    </div>
                                }
                                <Table className="fixedTable mt-1" responsive>
                                    <thead>
                                        <tr>
                                            <th style={{ width: "35%" }}>نام بخش</th>
                                            <th style={{ width: "25%" }} >مسئول بخش</th>
                                            <th style={{ width: "20%" }}>تلفن بخش</th>
                                            <th style={{ width: "13%" }}>داخلی</th>
                                            <th style={{ width: "7%" }}>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {relatedSections === "PENDING" &&
                                            <tr>
                                                <td colSpan={5}>
                                                    <Loader type="BallTriangle" color="#eebb1370" />
                                                </td>
                                            </tr>
                                        }
                                        {
                                            relatedSections && Array.isArray(relatedSections) &&
                                            relatedSections.map((item, i) =>
                                                <tr key={i} className="resultTableRow">
                                                    <td style={{ width: "35%" }}>{!item.SectionName || item.SectionName === "" ? "--" : item.SectionName}</td>
                                                    <td style={{ width: "25%" }}>{item.SectionResponsible}</td>
                                                    <td style={{ width: "20%" }}>{!item.SectionPhone || item.SectionPhone === "" ? "--" : item.SectionPhone}</td>
                                                    <td style={{ width: "13%" }}>{!item.SectionInternalNumber || item.SectionInternalNumber === "" ? "--" : item.SectionInternalNumber}</td>
                                                    <td style={{ width: "7%" }}><Trash color="red" size={15} className="rowBtn" onClick={() => deleteSection(item.ID)} /></td>
                                                </tr>)
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    }
                    <div className="mt-2" style={{ position: "sticky", bottom: "10px" }}>
                        <Button type="submit" variant="success" className="group-Btn" disabled={Number(customer?.RelatedCustomerID) > 0}>
                            {isPending && <Loader type="BallTriangle" color="white" height={20} width={20} />}
                            {!isPending && <Fragment><CheckLg /> ثبت اطلاعات</Fragment>}
                        </Button>
                        {Number(customer?.RelatedCustomerID) > 0 && <Button className="group-Btn" onClick={showRelatedCustomer}><FileEarmarkPerson size={18} />&nbsp;مشتری مرتبط</Button>}
                        {!(Number(customer?.RelatedCustomerID) > 0) && <Button className="group-Btn" onClick={convertToCustomer} disabled={!(Number(id) > 0)}><Toggles size={18} />&nbsp;تبدیل به مشتری</Button>}
                        {Number(id) > 0 && <button type="button" className="btn btn-violet btn-block  group-Btn" onClick={e => showMenu(e)}><List size={17} /></button>}
                    </div>
                </form>
            }
        </Fragment >
    )
}
export default CustomerInfo;